// Aviso de version nueva desplegada.
//
// Por que existe: el 7-ago se descubrio que operadores de RRHH llevaban dias
// viendo rotulos de catalogos que se habian renombrado el 1-ago. Pidieron
// cuatro cambios que ya estaban hechos y en produccion. Nadie tenia forma de
// notar que estaba mirando un bundle viejo.
//
// Como lo detecta: esta app NO tiene service worker, asi que no hay evento de
// actualizacion al que suscribirse. La senal confiable es el propio nombre del
// bundle: CRA compila a /static/js/main.<hash>.js, y el hash cambia en cada
// build. Si el index.html del servidor apunta a un hash distinto del que esta
// corriendo en esta pestana, hay una version nueva desplegada.
//
// Complemento necesario: staticwebapp.config.json manda no-cache para
// index.html (y cache larga para /static/*, que va con hash). Sin eso, el
// index.html que trae este componente podria ser tan viejo como el cargado.
import React, { useEffect, useRef, useState } from 'react';

const INTERVALO_MS = 10 * 60 * 1000;   // 10 min: la carga es un GET de index.html

function bundleDelDocumento() {
    const s = document.querySelector('script[src*="/static/js/main."]');
    if (!s) return null;
    const m = s.src.match(/main\.[A-Za-z0-9]+\.js/);
    return m ? m[0] : null;
}

async function bundleDelServidor() {
    const r = await fetch('/index.html', { cache: 'no-store' });
    if (!r.ok) return null;
    const html = await r.text();
    const m = html.match(/main\.[A-Za-z0-9]+\.js/);
    return m ? m[0] : null;
}

export default function AvisoNuevaVersion() {
    const actual = useRef(bundleDelDocumento());
    const [nueva, setNueva] = useState(null);
    const [descartada, setDescartada] = useState(null);

    useEffect(() => {
        // En desarrollo el bundle no lleva hash: no hay nada que comparar y
        // cualquier comparacion daria falsos positivos en cada recarga.
        if (process.env.NODE_ENV !== 'production') return;
        if (!actual.current) return;

        let vivo = true;
        const revisar = async () => {
            try {
                const remota = await bundleDelServidor();
                if (vivo && remota && remota !== actual.current) setNueva(remota);
            } catch {
                // Sin red, o el fetch fallo: no se avisa nada y se reintenta
                // en el proximo ciclo. Este componente nunca debe molestar.
            }
        };

        revisar();
        const iv = setInterval(revisar, INTERVALO_MS);
        // El caso real es la pestana abierta todo el dia: al volver a ella se
        // revisa, sin esperar al ciclo.
        const alVolver = () => { if (document.visibilityState === 'visible') revisar(); };
        document.addEventListener('visibilitychange', alVolver);

        return () => {
            vivo = false;
            clearInterval(iv);
            document.removeEventListener('visibilitychange', alVolver);
        };
    }, []);

    if (!nueva || nueva === descartada) return null;

    return (
        <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
            background: '#87B749', color: '#fff', padding: '8px 16px',
            fontFamily: 'Segoe UI, sans-serif', fontSize: 13, fontWeight: 600
        }}>
            <span>Hay una version nueva del sistema. Recarga para verla.</span>
            <button
                onClick={() => window.location.reload()}
                style={{
                    background: '#012E40', color: '#fff', border: 'none',
                    borderRadius: 6, padding: '5px 14px', fontSize: 12,
                    fontWeight: 600, cursor: 'pointer'
                }}>
                Recargar
            </button>
            <button
                onClick={() => setDescartada(nueva)}
                title="Ocultar hasta el proximo despliegue"
                style={{
                    background: 'transparent', color: 'rgba(255,255,255,0.85)',
                    border: 'none', fontSize: 16, lineHeight: 1, cursor: 'pointer'
                }}>
                &times;
            </button>
        </div>
    );
}
